import { useState, useEffect, useContext, createContext } from 'react';
import { useHttpClient } from '../hooks/http-hook';

const IngredientsContext = createContext();

export const IngredientsProvider = ({ children }) => {
  const [loadedIngredients, setLoadedIngredients] = useState();
  const { sendRequest } = useHttpClient();

  useEffect(() => {
    const fetchIngredientsRefs = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/cocktails/getAllIngredientRefs`
        );
        setLoadedIngredients(responseData.ingredients);
      } catch (err) {}
    };

    fetchIngredientsRefs();
  }, [sendRequest]);

  return (
    <IngredientsContext.Provider value={{ loadedIngredients }}>
      {children}
    </IngredientsContext.Provider>
  );
};

export const useIngredients = () => {
  return useContext(IngredientsContext);
};
